var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "iframe touch",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$store.commit('actions/SET_IFRAME_URL', '');
      }
    }
  }, [_c('div', {
    staticClass: "iframe__inner"
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "border": "none",
      "width": "100%",
      "height": "100%",
      "left": "0",
      "right": "0",
      "top": "0",
      "bottom": "0"
    },
    attrs: {
      "allow": "accelerometer 'none'; gyroscope 'none'; magnetometer 'none'",
      "src": _vm.url
    }
  }), _c('div', {
    staticClass: "iframe-close touch",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$store.commit('actions/SET_IFRAME_URL', '');
      }
    }
  }, [_c('fa', {
    attrs: {
      "icon": ['fas', 'times']
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }